import * as React from "react";
import { cn } from "@shared/lib/utils";

/**
 * Toggle switch component
 */
const Switch = React.forwardRef(({ className, checked, defaultChecked, onCheckedChange, disabled, ...props }, ref) => {
  const [internalChecked, setInternalChecked] = React.useState(defaultChecked || false);
  const isControlled = checked !== undefined;
  const isChecked = isControlled ? checked : internalChecked;

  const handleToggle = React.useCallback(() => {
    if (disabled) return;
    
    if (!isControlled) {
      setInternalChecked(!internalChecked);
    }
    onCheckedChange?.(!isChecked);
  }, [disabled, isControlled, internalChecked, isChecked, onCheckedChange]);

  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={disabled}
      onClick={handleToggle}
      className={cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        isChecked ? "bg-primary" : "bg-input",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-2 transition-transform",
          isChecked ? "translate-x-5 bg-gray-800 ring-gray-800" : "translate-x-0 bg-gray-600 ring-gray-600"
        )}
      />
    </button>
  );
});
Switch.displayName = "Switch";

export { Switch };
